import React from 'react';
import { Sun, Moon, LogOut } from 'lucide-react';
import { User } from '../../../types/auth.types';

interface SidebarFooterProps {
    sidebarOpen: boolean;
    isDarkMode: boolean;
    toggleTheme: () => void;
    logout: () => void;
    user: User | null;
}

export const SidebarFooter: React.FC<SidebarFooterProps> = ({
    sidebarOpen,
    isDarkMode,
    toggleTheme,
    logout,
    user
}) => {
    return (
        <>
            <div className="p-4 border-t border-[var(--border-color)] space-y-2">
                <button
                    onClick={toggleTheme}
                    className="w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-[var(--text-secondary)] hover:bg-[var(--bg-tertiary)] transition-all"
                >
                    {isDarkMode ? <Sun size={20} /> : <Moon size={20} />}
                    {sidebarOpen && <span className="font-medium">{isDarkMode ? 'Light Mode' : 'Dark Mode'}</span>}
                </button>
                <button
                    onClick={logout}
                    className="w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-red-500 hover:bg-red-50 dark:hover:bg-red-900/20 transition-all"
                >
                    <LogOut size={20} />
                    {sidebarOpen && <span className="font-medium">Logout</span>}
                </button>
            </div>

            {sidebarOpen && user && (
                <div className="p-4 border-t border-[var(--border-color)]">
                    <div className="flex items-center gap-3">
                        <div className="w-10 h-10 rounded-full bg-primary-500 flex items-center justify-center text-white font-bold">
                            {user.displayName?.charAt(0) || 'U'}
                        </div>
                        <div className="flex-1 min-w-0">
                            <p className="text-sm font-medium text-[var(--text-primary)] truncate">
                                {user.displayName}
                            </p>
                            <p className="text-xs text-[var(--text-secondary)] truncate">
                                {user.role}
                            </p>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};
